import axios from "../config/axios";

const API_BASE = "/agent-partnerships";

const agentPartnershipService = {
  list: (params = {}) => axios.get(API_BASE, { params }),
  get: (partnershipId) => axios.get(`${API_BASE}/${partnershipId}`),
  request: (data) => axios.post(`${API_BASE}/request`, data),
  respond: (partnershipId, data) => axios.put(`${API_BASE}/${partnershipId}/respond`, data),
  revoke: (partnershipId) => axios.put(`${API_BASE}/${partnershipId}/revoke`),
  validate: (params) => axios.get(`${API_BASE}/validate`, { params }),
};

export default agentPartnershipService;
